import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import React__default from 'react';
import { TooltipV2 } from '../tooltip-v2/tooltip-v2.js';
import { Icon } from '../icon/icon.js';
import { borderRadiusFull, intentPrimary, intentSuccess, intentWarning, intentDanger } from '../theme/theme.js';
import { Information32 } from '@carbon/icons-react';
import cx from 'classnames';

var _excluded = ["className", "content", "intent"];

var StyledIcon = /*#__PURE__*/_styled(Icon, {
  target: "ebjc2t90"
})("border-radius:", borderRadiusFull, ";color:", function (_ref) {
  var intent = _ref.intent;
  return intent === "primary" ? intentPrimary : intent === "success" ? intentSuccess : intent === "warning" ? intentWarning : intent === "danger" ? intentDanger : undefined;
}, ";");

var InfoTooltip = /*#__PURE__*/React__default.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
      content = _ref2.content,
      intent = _ref2.intent,
      props = _objectWithoutProperties(_ref2, _excluded);

  var combinedClassName = cx("vds-info-tooltip", className);
  return /*#__PURE__*/React__default.createElement(TooltipV2, _extends({
    className: combinedClassName,
    content: content,
    delayDuration: 0,
    ref: ref
  }, props), /*#__PURE__*/React__default.createElement(StyledIcon, {
    className: "vds-info-tooltip-trigger",
    intent: intent,
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement(Information32, null)));
});

export { InfoTooltip };
//# sourceMappingURL=info-tooltip.js.map
